import { BaseCartridge, RomImage } from './base';

/** Mapper 0 — NROM. 16/32KB PRG, 8KB CHR ROM or CHR-RAM. */
export class NromCartridge extends BaseCartridge {
    constructor(image: RomImage) {
        super(image);
    }

    cpuRead(address: number): number {
        const ram = { value: 0 };
        if (this.readPrgRam(address, ram)) return ram.value;
        if (address >= 0x8000) {
            // 16KB or 32KB PRG ROM; 16KB mirrored at 0xC000.
            return this.prgRom[(address - 0x8000) % this.prgRom.length];
        }
        return 0;
    }

    cpuWrite(address: number, value: number): void {
        this.writePrgRam(address, value); // NROM has no mapper registers
    }

    ppuRead(address: number): number {
        return this.chr[address & (this.chr.length - 1)];
    }

    ppuWrite(address: number, value: number): void {
        if (this.chrIsRam) {
            this.chr[address & (this.chr.length - 1)] = value & 0xFF;
        }
    }
}
